import React from "react";
import { Form, Input, Button, Typography, Spin } from "antd";
import styled from "styled-components";
import { MailOutlined, MessageOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { sendContactMessage } from "../../Services/contact_us";

import logo from "../../assets/Images/Frame 45.png";
import {
  ContentContainer,
  Logo,
  LogoContainer,
  PageWrapper,
} from "../../Styles/CommonStyle";

const { Paragraph } = Typography;
const { TextArea } = Input;

// Styled Components
const FormWrapper = styled(Form)`
  .ant-form-item {
    margin-bottom: 20px;
  }
`;

const StyledParagraph = styled(Paragraph)`
  text-align: left;
  font-size: 14px;
  color: #666;
  margin-bottom: 30px;
`;

const SubmitButton = styled(Button)`
  width: 100%;
`;

const ContentWrapper = styled.div`
  max-width: 500px;
  margin: -20px auto;
  width: 100%;
`;

const ContactUs = () => {
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: sendContactMessage,
    onSuccess: () => {
      form.resetFields();
    },
    onError: () => {
      // Handle error if needed
    },
  });

  const onFinish = (values) => {
    mutation.mutate(values);
  };

  return (
    <PageWrapper>
      <LogoContainer>
        <Logo src={logo} alt="Logo" />
      </LogoContainer>

        <ContentWrapper>
            <ContentContainer>
                <h3>Contact Us</h3>
                <StyledParagraph>
                    Need help or have questions? Send us a message and we'll get back to you shortly.
                </StyledParagraph>
                <Spin spinning={mutation.isPending}>
                    <FormWrapper
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                    autoComplete="off"
                    >
                    <Form.Item
                        name="email"
                        label="Your Email"
                        rules={[
                        { required: true, message: "Please enter your email address" },
                        { type: "email", message: "Please enter a valid email address" },
                        ]}
                    >
                        <Input
                        prefix={<MailOutlined />}
                        placeholder="Enter your email"
                        />
                    </Form.Item>

                    <Form.Item
                        name="subject"
                        label="Subject"
                        rules={[{ required: true, message: "Please enter a subject" }]}
                    >
                        <Input
                        prefix={<MessageOutlined />}
                        placeholder="Enter subject"
                        />
                    </Form.Item>

                    <Form.Item
                        name="message"
                        label="Message"
                        rules={[{ required: true, message: "Please enter your message" }]}
                    >
                        <TextArea
                        rows={5}
                        placeholder="Type your message here..."
                        />
                    </Form.Item>

                    <Form.Item>
                        <SubmitButton
                        type="primary"
                        htmlType="submit"
                        loading={mutation.isPending}
                        >
                        Send Message
                        </SubmitButton>
                    </Form.Item>
                    </FormWrapper>
                </Spin>
            </ContentContainer>
        </ContentWrapper>
    </PageWrapper>
  );
};

export default ContactUs;
